import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { ClassRoomsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export const useClassRoomGet = (id: number) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.ClassRooms, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(ClassRoomsApi, accessToken);
      return service.getClassRoomById({ id });
    },
    enabled: !!accessToken && !!id,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};

